module.exports = __webpack_public_path__ + "static/img/equityCard.6cca8f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/equityCard.png
// module id = 3uEu
// module chunks = 0